import {Component, OnInit} from "@angular/core";
import {DialogComponent} from '../../../../../ng2-bootstrap-modal/dialog.component';
import {DialogService} from '../../../../../ng2-bootstrap-modal/dialog.service';

@Component({
    selector: 'db-third-party-theme-activation-dialog',
    templateUrl: './third-party-theme-activation-dialog.component.html',
    styleUrls: ['./third-party-theme-activation-dialog.component.scss'],
    standalone: false
})
export class ThirdPartyThemeActivationDialogComponent extends DialogComponent<null, Boolean> implements OnInit {
  public loading: boolean;

  constructor(
    private _dialogService: DialogService
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {

  }

  public cancel(): void {
    this.result = false;
    this.close();
  }

  public confirm(): void {
    this.result = true;
    this.close();
  }

}
